import { render, staticRenderFns } from "./MealRatingPrompt.vue?vue&type=template&id=52ef6ae4&scoped=true"
import script from "./MealRatingPrompt.vue?vue&type=script&lang=js"
export * from "./MealRatingPrompt.vue?vue&type=script&lang=js"
import style0 from "./MealRatingPrompt.vue?vue&type=style&index=0&id=52ef6ae4&prod&scoped=true&lang=css"
import style1 from "./MealRatingPrompt.vue?vue&type=style&index=1&id=52ef6ae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef6ae4",
  null
  
)

export default component.exports